import React, { Component } from 'react';
import OpenViduVideoComponent from './OvVideo';
import './UserVideo.css';
import { BsBroadcast } from "react-icons/bs";
export default class UserVideoComponent extends Component {

    getNicknameTag() {
        // Gets the nickName of the user
        return JSON.parse(this.props.streamManager.stream.connection.data).clientData;
    }

    render() {
        return (
            <div>
                {this.props.streamManager !== undefined ? (
                    <div className="streamcomponent">
                        <OpenViduVideoComponent streamManager={this.props.streamManager} />
                         <div className='stream_info'>
                                 <p style={{color:"red"}}>{this.getNicknameTag()}</p> 
                                 {
                                    this.props.session && (
                                        <div className='blink'>
                                        <p style={{color:"red"}}>
                                            <BsBroadcast style={{width:"20px", color:"red"}}/> Live
                                        </p>
                                    </div>
                                    )
                                 }
                                 {
                                    this.props.theSession && <div className='blink'>
                                    <p style={{color:"orange"}}>
                                         Show Live
                                    </p> </div>
                                 }
                                 
                         </div>
                         
                    </div>
                ) : null}
            </div>
        );
    }
}
